export default __webpack_public_path__ + "static/media/PST-Knowledge-01.e22d6f6c.jpg";